"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUpdateQuery = void 0;
const core_ui_1 = require("@sierralabs/core-ui");
function useUpdateQuery(id) {
    const { data, isLoading, error, put } = (0, core_ui_1.useApiPut)(`queries/${id}`);
    return {
        updatedQuery: data,
        updating: isLoading,
        updateError: error,
        updateQuery: put
    };
}
exports.useUpdateQuery = useUpdateQuery;
//# sourceMappingURL=useUpdateQuery.js.map